import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Actions } from '../../actions';
import { SetActiveArtist } from '../../artist/action-creators';
import { SET_ACTIVE_ARTIST } from '../../artist/actions';
import { getOrderKey } from '../utils';
import { CreateOrder } from '../action-creators';
import { NoOp } from '../../ui/action-creators';

export const loadOrderCacheEpic = (action$: Observable<Actions>) =>
  action$.pipe(
    ofType<Actions, SetActiveArtist>(SET_ACTIVE_ARTIST),
    map((action) => {
      const key = getOrderKey(action.artist.id);

      const previousOrder = localStorage.getItem(key);

      if (previousOrder) {
        return new CreateOrder(JSON.parse(previousOrder));
      }

      return new NoOp();
    })
  );
